module.exports = __webpack_public_path__ + "static/media/img31.fb7ea2b0.jpg";